import { render } from "./SIThoughtTrace.vue?vue&type=template&id=48edf6b7&scoped=true"
import script from "./SIThoughtTrace.vue?vue&type=script&lang=js"
export * from "./SIThoughtTrace.vue?vue&type=script&lang=js"

import "./SIThoughtTrace.vue?vue&type=style&index=0&id=48edf6b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48edf6b7"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSpinnerDots});
